import AutomaticRepliesViewState from 'mini-options-store/lib/store/schema/AutomaticRepliesViewState';
import setIsAutomaticRepliesEnabled from '../../actions/automaticReplies/setIsAutomaticRepliesEnabled';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

const setIsAutomaticRepliesEnabledMutator = mutator(setIsAutomaticRepliesEnabled, actionMessage => {
    const store = getOptionsStore();
    const { status } = actionMessage;
    if (store && store.activeViewState) {
        const viewState = store.activeViewState as AutomaticRepliesViewState;
        if (status !== viewState.isAutomaticRepliesEnabled) {
            viewState.isAutomaticRepliesEnabled = status;
            viewState.isDirty = true;
        }
    }
});

export default setIsAutomaticRepliesEnabledMutator;
